import React from "react";
import MainFrame from "@/Layout/Layout";
import { SliderSection } from "@/pages/home/components/SliderSection";
import { MainPartnersSection } from "@pages/home/components/MainPartnersSection";
import { SelfSellingSection } from "@pages/home/components/SelfSellingSection";
import { SimplifiedContactForm } from "@pages/contact/ContactUsView";

const HomeView: React.FC = () => {
  return (
    <MainFrame>
      <SliderSection />
      <MainPartnersSection />
      <SelfSellingSection />
      <SimplifiedContactForm />
    </MainFrame>
  );
};

export default HomeView;
